import { EmployeePermission } from 'src/api/permissions';
import { AdministratorPage } from 'src/pages/AdministratorPage/AdministratorPage';
import { DeskBookingPage } from 'src/pages/DeskBookingPage/DeskBookingPage';
import { MainPage } from 'src/pages/MainPage/MainPage';
import { MyBookingsPage } from 'src/pages/MyBookingsPage/MyBookingsPage';
import ParkingPage from 'src/pages/ParkingPage/ParkingPage';
import { RoomBookingPage } from 'src/pages/RoomBookingPage/RoomBookingPage';
import { SearchPage } from 'src/pages/SearchPage/SearchPage';
import { SpacesPage } from 'src/pages/SpacesPage/SpacesPage';

import { RouteInfo, RoutePath } from './types';

export const routes: RouteInfo[] = [
  {
    path: RoutePath.Main,
    Element: MainPage,
  },
  {
    path: RoutePath.Administrator,
    Element: AdministratorPage,
    permission: EmployeePermission.EditPlans,
  },
  {
    path: RoutePath.Spaces,
    Element: SpacesPage,
    permission: EmployeePermission.EditPlans,
  },
  {
    path: RoutePath.DeskBooking,
    Element: DeskBookingPage,
    permission: EmployeePermission.BookDesks,
  },
  {
    path: RoutePath.RoomBooking,
    Element: RoomBookingPage,
    permission: EmployeePermission.BookRooms,
  },
  {
    path: RoutePath.Parking,
    Element: ParkingPage,
    permission: EmployeePermission.BookDesks,
  },
  {
    path: RoutePath.MyBookings,
    Element: MyBookingsPage,
    permission: EmployeePermission.ViewBookedObjects,
  },
  {
    path: RoutePath.Search,
    Element: SearchPage,
    permission: EmployeePermission.ViewBookedObjects,
  },
  // {
  //   path: RoutePath.Feedback,
  //   Element: FeedbackPage,
  //   permission: EmployeePermission.ViewFeedbacks,
  // },
];
